import { IStudentsDashboardFilterOptions } from '@/store/dashboard/types';
import { IRegionConfigsState } from '@/store/region_config_dashboard/types';
import { uiTypes } from 'shared-components';
import { IAgent, ISystemAndUniConfig, IProgrammableTag, IStudentRow } from 'api-paths-cas';

export interface IGetFilterGroupsProps {
  activeFilters: {
    [key: string]: string[];
  };
  agents?: IAgent[];
  regionConfigs?: IRegionConfigsState;
  config?: ISystemAndUniConfig;
  isPathway?: boolean;
  programmableTags?: IProgrammableTag[];
  userRole?: uiTypes.UserRole;
  students?: IStudentRow[];
  filterOptions?: IStudentsDashboardFilterOptions;
}

export enum RegionSelection {
  UK = 'UK',
  MIDDLE_EAST = 'Middle East',
  AFRICA = 'Africa',
  NON_EU_EUROPE = 'Non-EU Europe',
  CENTRAL_ASIA = 'Central Asia (CIS)',
  NORTH_AMERICA = 'North America',
  SOUTH_AMERICA = 'South America',
  SOUTH_ASIA = 'South Asia',
  SOUTHEAST_ASIA = 'Southeast Asia',
  EAST_ASIA = 'East Asia',
  EUROPE = 'Europe',
}
